import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import SvgChevronLeft from '@img/icons/header/chevron-left.svg';
import SvgChevronRight from '@img/icons/header/chevron-right.svg';
import styled from 'styled-components';
import { customNavScrollbarStyles } from '../../Header.styles';

const Container = styled.nav`
  position: fixed;
  top: var(--headerHeight);
  left: 0;
  display: flex;
  flex-direction: column;
  background: ${brand.white};
  height: calc(100% - var(--headerHeight));
  overflow-y: auto;
  ${customNavScrollbarStyles}
  padding: 16px;
  transition: top 0.15s ease-out;
  width: 100%;
  z-index: 100;

  &[aria-hidden='true'] {
    display: none;
  }

  @media ${from(Device.DesktopSmall)} {
    display: none;
  }
`;

const ItemList = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Item = styled.li`
  display: block;
  flex: 1 0 100%;
  width: 100%;

  &[data-flex-item='true'] {
    flex: 1 0 calc(50% - 8px);
    width: 50%;
  }
`;

const Link = styled.a`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  ${fonts.helvetica['73-bold-extended']}
  font-size: 16px;
  line-height: 22px;
  color: ${brand.black};
  padding: 11px 8px;
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;

  ${() => LinksWrapper} & {
    place-content: center;
    ${fonts.helvetica['63-medium-extended']}
    font-size: 14px;
    line-height: 1em;
    padding: 10px 0;
  }

  [data-flex-item='true'] & {
    flex-wrap: wrap;

    span {
      width: calc(100% - 24px);
    }

    > svg {
      margin-top: auto;
    }
  }

  span {
    display: inline-flex;
    place-items: center;
    gap: 0 8px;

    &[data-new='true'],
    &[data-new='true'] span {
      display: inline-block;
      display: ruby; /* aligns adjaceent spans */
    }
  }
`;

const New = styled.span`
  display: inline-flex;
  place-items: center;
  ${fonts.helvetica['93-black-extended']}
  font-size: 9px;
  line-height: 1em;
  letter-spacing: 0.16px;
  color: ${brand.white};
  background-color: ${brand.red.base};
  text-transform: uppercase;
  height: 12px;
  padding: 0 3px;
  border-radius: 2px;
`;

const Logo = styled.div`
  display: flex;
  place-items: center;
  place-content: center;
  width: 100%;
  height: 130px;
  padding: 0 14px;
  margin-bottom: 8px;
  background-color: ${brand.grey[97]};

  svg {
    height: var(--systemLogoHeight);
  }
`;

const BackLink = styled.div`
  position: relative;
  display: inline-flex;
  place-items: center;
  width: 100%;
  gap: 0 4px;
  padding: 8px;
  ${fonts.helvetica['73-bold-extended']}
  font-size: 14px;
  line-height: 22px;
  color: ${brand.black};
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;
`;

const ParentLink = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  place-items: flex-start;
  place-content: flex-start;
  gap: 18px 0;
  width: 100%;
  margin: 0;
  padding: 8px 8px 18px;
  margin-bottom: 18px;
  border-bottom: 2px solid ${brand.grey[80]};

  a,
  span {
    ${fonts.helvetica['83-heavy-extended']}
    font-size: 18px;
    line-height: 22px;
    color: ${brand.black};
    text-transform: uppercase;
  }

  a {
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  svg {
    height: var(--systemLogoHeight);
  }
`;

const LeftArrow = styled(SvgChevronLeft)`
  display: block;
  flex-shrink: 0;
  height: 12px;
  width: 12px;
  cursor: pointer;
`;

const RightArrow = styled(SvgChevronRight)`
  display: block;
  flex-shrink: 0;
  height: 16px;
  width: 16px;
  margin-left: 8px;
`;

const LinksWrapper = styled.div`
  text-align: center;
  padding-top: 16px;
  margin-top: auto;
  border-top: 2px solid ${brand.grey[80]};
`;

const MobileNavigationStyles = {
  Container,
  Item,
  ItemList,
  LeftArrow,
  Link,
  New,
  Logo,
  BackLink,
  ParentLink,
  RightArrow,
  LinksWrapper,
};

export default MobileNavigationStyles;
